import { jsx as _jsx } from "react/jsx-runtime";
import { useBEM } from "@geome/react-next/lib/hooks/useBEM";
import { CrossIcon } from "../icons/cross";
const CollapsibleIcon = ({ open, renderIcon }) => {
    const collapsibleIconClassname = useBEM({
        block: "section-with-title",
        element: "collapsible-icon",
        modifiers: {
            open: open,
        },
    });
    if (renderIcon) {
        return renderIcon(open);
    }
    return _jsx(CrossIcon, { size: 14, className: collapsibleIconClassname });
};
export { CollapsibleIcon };
